/*******************************************************************************
 * MissingReceiptsAdminProvider */
/**
 * Provider for the missing receipts admin HTTP service: creates the deposit and
 * receipt for a web order, and loads the deposit/receipt info and the web orders
 * list.
 *******************************************************************************/
export function MissingReceiptsAdminProvider() {
  'use strict';
  this.httpServiceBase = '/books/missingReceiptsAdmin/';

  this.$get = [
    'HTTPService',
    function (HTTPService) {
      return HTTPService.make(this.httpServiceBase, {
        createDepositAndReceipt: function (
          receipt,
          deposit,
          webOrder,
          remainderTender
        ) {
          return this.post('createDepositAndReceipt', {
            receipt,
            deposit,
            webOrder,
            remainderTender: remainderTender || null
          });
        },
        getDepositAndReceiptInfo: function (webOrderID, remainderTender) {
          return this.post('getDepositAndReceiptInfo', {
            webOrderID,
            remainderTender: remainderTender || null
          });
        },
        getWebOrdersList: function () {
          return this.get('getWebOrdersList');
        }
      });
    }
  ];
}
